import { SearchObject } from "app/common/Model/SearchObject";
import { reportRevenueDetails } from "app/services/ReportService";
import { exportExcelRevenueDetailsReport } from "app/services/VoucherItemService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportRevenueDetailsStore {
  listDataRevenueDetails = null;
  searchReportRevenueDetails = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    listDepId: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearch = (searchReportRevenueDetails) => {
    this.searchReportRevenueDetails = {
      ...this.searchReportRevenueDetails,
      ...searchReportRevenueDetails,
    };
    this.pagingReportRevenueDetails();
  };

  pagingReportRevenueDetails = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportRevenueDetails.listDepId || this.searchReportRevenueDetails.listDepId.length === 0) {
      this.listDataRevenueDetails = null;
      return;
    }

    const ortherData = this.normalizeSearchReport(
      this.searchReportRevenueDetails
    );
    return await reportRevenueDetails({ ...ortherData })
      .then(({ data }) => {
        this.listDataRevenueDetails = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo doanh số có lỗi");
      });
  };

  handleExportExcelRevenueDetailsReport = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = this.normalizeSearchReport(searchObj);
    try {
      const response = await exportExcelRevenueDetailsReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_DOANH_THU_CHI_TIET.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReport = (rawSearch = {}) => {
    const {
      listDepId,
      voucherInvoiceTypes,
      reportGroupId,
      serviceGroupId,
      ...rest
    } = rawSearch;
    return {
      ...rest,
      listDepId: listDepId?.map((el) => el?.id) || null,
      reportGroupId: reportGroupId?.id || null,
      serviceGroupId: serviceGroupId?.id || null,
      // voucherInvoiceTypes: voucherInvoiceTypes?.map((el) => el?.value),
    };
  };

  resetStore = () => {
    this.listData = null;
    this.searchFee = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };
}
